"use client";
import { motion } from "motion/react";
interface Props {
  image: string;
  link: string;
  label?: string;
  className?: string;
  imgClassName?: string;
  imgWidth?: number;
  imgHeight?: number;
}

const IconLink = ({
  link,
  image,
  label = "",
  className = "",
  imgClassName = "flex-none h-7",
  imgWidth = 28,
  imgHeight = 28,
}: Props) => {
  className = "iconlink align-middle mx-2" + className;

  const clickLink = () => {
    window.open(link);
  };

  return (
    <motion.button
      className={className}
      whileHover={{
        scale: 1.05,
        backgroundColor: "var(--shadowcolor)",
        filter: "grayscale(0%)",
      }}
      whileTap={{ scale: 1, backgroundColor: "var(--shadowcolor)" }}
      onClick={clickLink}
    >
      {label && <span className="sr-only">{label}</span>}
      <img className={imgClassName} src={image} width={imgWidth} height={imgHeight} alt="" />
    </motion.button>
  );
};

export default IconLink;
